module.exports = __webpack_public_path__ + "static/media/check-circle-fill.a376e970.svg";